import styleSearch from "./Search.module.scss";
import classNames from "classnames";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export const Search = ({value, setValue, placeholder}) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(styleSearch.search_cont)}>
      <Form.Control
        type="text"
        placeholder={placeholder}
        aria-label="Search-input"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className={styleSearch.search}
      />
    </div>
  );
};

